var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUiSmallLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 30,
    viewBox: "0 0 67 30",
    fill: "#0000FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1580_1858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7561 15.6139V6.26135H21.0739V15.1713C21.0739 16.9882 21.872 18.5825 24.0957 18.5825H27.3591C29.6064 18.5825 30.381 16.9868 30.381 15.1713V6.26135H35.6987V15.6125C35.6987 20.9379 32.5325 23.7359 27.3605 23.7359H24.0971C18.9251 23.7359 15.7589 20.9379 15.7589 15.6125L15.7561 15.6139Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0024 6.26135H44.3202V23.4427H39.0024V6.26135Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0382 30C22.1233 30 14.6665 28.503 9.04477 25.784C3.21203 22.962 0 19.1322 0 14.9993C0 10.8664 3.21203 7.0366 9.04477 4.21604C14.6665 1.49697 22.1233 0 30.0382 0C37.953 0 45.4084 1.49697 51.0316 4.21604C56.8643 7.0366 60.0763 10.8664 60.0763 14.9993C60.0763 19.1322 56.8643 22.962 51.0316 25.7825C45.4098 28.5016 37.953 29.9986 30.0382 29.9986V30ZM30.0382 1.80849C22.3829 1.80849 15.1981 3.24343 9.8096 5.84974C4.63204 8.35315 1.78091 11.6022 1.78091 14.9993C1.78091 18.3964 4.63204 21.6469 9.81099 24.1503C15.1995 26.7566 22.3829 28.1915 30.0396 28.1915C37.6962 28.1915 44.8796 26.7566 50.2681 24.1503C55.4457 21.6454 58.2982 18.3964 58.2982 14.9993C58.2982 11.6022 55.4471 8.35174 50.2681 5.84833C44.8796 3.24202 37.6962 1.80708 30.0396 1.80708L30.0382 1.80849Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiSmallLogo);
export default __webpack_public_path__ + "static/media/ui_small_logo.ce7fdfd7d42137915677b6c1a1700226.svg";
export { ForwardRef as ReactComponent };